import { getSentry } from '~/utility/lazySentry'

export default defineNuxtPlugin((nuxtApp) => {
  // All wrapper methods use dynamic import to keep Sentry out of the main bundle.
  // Callers fire-and-forget, so the async nature is transparent.
  const sentryWrapper = {
    captureException: (error: any, context?: any) => {
      getSentry()
        .then((s) => s.captureException(error, context))
        .catch(() => {})
    },
    captureMessage: (message: string, level?: any) => {
      getSentry()
        .then((s) => s.captureMessage(message, level))
        .catch(() => {})
    },
    setContext: (key: string, context: any) => {
      getSentry()
        .then((s) => s.setContext(key, context))
        .catch(() => {})
    },
    setTag: (key: string, value: any) => {
      getSentry()
        .then((s) => s.setTag(key, value))
        .catch(() => {})
    },
    setExtra: (key: string, extra: any) => {
      getSentry()
        .then((s) => s.setExtra(key, extra))
        .catch(() => {})
    },
    showReportDialog: (options?: any) => {
      if (process.client) {
        import('@sentry/browser')
          .then((s) => {
            if (s.showReportDialog) {
              s.showReportDialog(options)
            }
          })
          .catch(() => {})
      }
    },
  }

  // Provide $sentry wrapper
  nuxtApp.provide('sentry', sentryWrapper)

  // Provide $sentryReady that returns a promise resolving to the wrapper
  // eslint-disable-next-line require-await -- TODO: Review if async is needed for compatibility
  nuxtApp.provide('sentryReady', async () => {
    // For @sentry/nuxt, Sentry is immediately available after import
    return sentryWrapper
  })
})

// Type declarations for compatibility wrapper
declare module 'nuxt/app' {
  interface NuxtApp {
    $sentry: {
      captureException: (error: any, context?: any) => any
      captureMessage: (message: string, level?: any) => any
      setContext: (key: string, context: any) => void
      setTag: (key: string, value: any) => void
      setExtra: (key: string, extra: any) => void
      showReportDialog: (options?: any) => void
    }
    $sentryReady: () => Promise<{
      captureException: (error: any, context?: any) => any
      captureMessage: (message: string, level?: any) => any
      setContext: (key: string, context: any) => void
      setTag: (key: string, value: any) => void
      setExtra: (key: string, extra: any) => void
      getClient: () => any
      showReportDialog: (options?: any) => void
    }>
  }
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $sentry: {
      captureException: (error: any, context?: any) => any
      captureMessage: (message: string, level?: any) => any
      setContext: (key: string, context: any) => void
      setTag: (key: string, value: any) => void
      setExtra: (key: string, extra: any) => void
      getClient: () => any
      showReportDialog: (options?: any) => void
    }
    $sentryReady: () => Promise<{
      captureException: (error: any, context?: any) => any
      captureMessage: (message: string, level?: any) => any
      setContext: (key: string, context: any) => void
      setTag: (key: string, value: any) => void
      setExtra: (key: string, extra: any) => void
      getClient: () => any
      showReportDialog: (options?: any) => void
    }>
  }
}
